import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const EKGPage = () => {
  return (
    <Layout>
      <PageHero
        title="EKG (Ruhe & Langzeit): Ihr Herz im Fokus"
        subtitle="Präzise Messung der elektrischen Herzaktivität für eine genaue Beurteilung Ihrer Herzgesundheit."
        backgroundImage="/images/Kardiologie.webp"
        ctaText="EKG-Termin buchen"
      />

      <ContentSection
        title="Das Elektrokardiogramm – mehr als nur ein Schnappschuss"
        content="Das Ruhe-EKG liefert uns ein sofortiges Bild der Herzstromkurve. Für eine umfassendere Analyse, insbesondere zur Erkennung von Herzrhythmusstörungen, die nur zeitweise auftreten, führen wir auch Langzeit-EKGs durch, bei denen Ihre Herzaktivität über 24 Stunden aufgezeichnet wird."
        image="/images/Kardiologie.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Herzstrommessung (EKG) in Diez"
        content="Lassen Sie Ihre Herzgesundheit von den Spezialisten der Gemeinschaftspraxis Dres. von Bergh in Diez durch Ruhe- und Langzeit-EKGs beurteilen."
      />

      <CTASection
        title="Benötigen Sie eine EKG-Untersuchung?"
        subtitle="Kontaktieren Sie uns für eine Terminvereinbarung."
        buttonText="Jetzt Termin anfragen"
      />
    </Layout>
  );
};

export default EKGPage;
